import React, { Component } from "react";
import { DragLayer } from "react-dnd";
import { DND_KEY, DND_PIRATE, DND_PRIZE } from "../../constants";
import styles from "./DragLayer.css";

import Prize from "../Prizes/Prize";
import Key from "../Keyboard/Key";
import Pirate from "../Pirate/Pirate";

const collect = monitor => ({
  dragItem: monitor.getItem(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging(),
  itemType: monitor.getItemType()
});

@DragLayer(collect)
export default class DragLayerComponent extends Component {
  getItemStyles = () => {
    const { currentOffset } = this.props;
    const { x, y } = currentOffset;
    return {
      transform: `translate3d(${x}px,${y}px,0)`,
      WebkitTransform: `translate3d(${x}px,${y}px,0)`
    };
  };

  render() {
    const { isDragging, currentOffset } = this.props;

    if (!isDragging || !currentOffset) {
      return null;
    }

    return (
      <div className={styles.dragLayer} style={this.getItemStyles()}>
        {this.renderItem()}
      </div>
    );
  }

  renderItem = () => {
    /*
    return (
      <div style={{ width: 100, height: 100, backgroundColor: "red" }}>
        {this.props.currentOffset.x},{this.props.currentOffset.y}
      </div>
    );
    */
    switch (this.props.itemType) {
      case DND_KEY:
        return (
          <div className={styles.key}>
            <Key {...this.props.dragItem} />
          </div>
        );
      case DND_PRIZE:
        return (
          <div className={styles.prize}>
            <Prize {...this.props.dragItem} />
          </div>
        );
      case DND_PIRATE:
        return (
          <div className={styles.pirate}>
            <Pirate />
          </div>
        );
      default:
        return null;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/DragLayer/DragLayer.js